import type { ChatMessage } from '@/stores/chat-store'
import { Check, Copy, RefreshCw } from 'lucide-react'
import { useState } from 'react'

interface MessageFeedbackProps {
  msg: ChatMessage
  onRegenerate?: () => void
}

export function MessageFeedback({ msg, onRegenerate }: MessageFeedbackProps) {
  const [copied, setCopied] = useState(false)
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(msg.content)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <div className="flex items-center gap-0.5 mt-1 px-1">
      <button
        type="button"
        onClick={handleCopy}
        className="p-1 rounded hover:bg-muted transition-colors"
        title="Copy"
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-success-600" />
        ) : (
          <Copy className="h-3.5 w-3.5 text-muted-foreground" />
        )}
      </button>
      {/* <button
        type="button"
        onClick={() => handleRate('up')}
        className="p-1 rounded hover:bg-muted transition-colors"
        title="Good response"
      >
        <ThumbsUp
          className={`h-3.5 w-3.5 ${rating === 'up' ? 'text-brand-600 fill-brand-600' : 'text-muted-foreground'}`}
        />
      </button>
      <button
        type="button"
        onClick={() => handleRate('down')}
        className="p-1 rounded hover:bg-muted transition-colors"
        title="Bad response"
      >
        <ThumbsDown
          className={`h-3.5 w-3.5 ${rating === 'down' ? 'text-red-600 fill-red-600' : 'text-muted-foreground'}`}
        />
      </button> */}
      {/* <button type="button" className="p-1 rounded hover:bg-muted transition-colors" title="Share">
        <Share className="h-3.5 w-3.5 text-muted-foreground" />
      </button> */}
      {onRegenerate && (
        <button
          type="button"
          onClick={onRegenerate}
          className="p-1 rounded hover:bg-muted transition-colors"
          title="Regenerate"
        >
          <RefreshCw className="h-3.5 w-3.5 text-muted-foreground" />
        </button>
      )}
      {/* <button type="button" className="p-1 rounded hover:bg-muted transition-colors" title="More">
        <MoreHorizontal className="h-3.5 w-3.5 text-muted-foreground" />
      </button> */}
    </div>
  )
}
